<template>
  <div class="p_f head_o" :class="isWhite ? 'bc_w' : ''">
    <div class="head_out d_f ali_c">
      <template v-if="!$route.query.backHome">
        <div class="back cur_p t_l" v-if="!isWhite"><img @click="back" src="../assets/img/th_back.png" alt=""></div>
        <div class="back cur_p t_l" v-else><img @click="$router.go(-1)" src="../assets/img/th_back_b.png" alt=""></div>
      </template>
      <div class="flex_1 t_a">{{title}}</div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "topHead",
    props:{
      title:{//标题
        type:String,
        default:''
      },
      isWhite:{//是否是白色背景
        type:Boolean,
        default:false
      },
      closePop:{//是否是弹窗的头部组件
        type:Boolean,
        default:false
      },
    },
    data() {
      return {}
    },
    methods: {
      back(){
        if(this.closePop){
          this.$emit('close')
        }else{
          this.$router.go(-1);
        }
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
